import { Context } from 'chartjs-plugin-datalabels';
import { Palette } from '@infoods/lifebase-ui';

export const getDataLabelColor = (context: Context, palette: Palette) => {
  const isFirst = context.dataIndex === 0;
  const isLast = context.dataIndex === context.dataset.data.length - 1;
  const isActive = context.active;

  return isFirst || isLast || isActive ? palette.mainBlack : 'transparent';
};
